import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative mb-12 overflow-x-hidden lg:mt-12',
    bg: 'absolute inset-0 h-full w-full object-cover',
    row: 'relative z-1 flex items-center justify-center max-xl:flex-wrap xl:min-h-160',
    visual: 'relative flex xl:w-1/2',
    product: 'flex py-8 max-xl:mx-5 xl:w-1/2 xl:py-0',
    imageWrap: 'relative w-fit max-xl:mx-auto',
    image: 'max-xl:max-w-[375px] xl:h-auto xl:max-w-none',
    label:
      'px-5 text-[16px] leading-[1.2] font-light tracking-[0.2em] uppercase xl:absolute xl:z-2 xl:w-max xl:px-0 xl:text-[18px] xl:leading-[2]',
    refill:
      'mt-5 mb-8 flex h-[163px] w-[273px] items-center gap-2 max-xl:mx-5 xl:absolute xl:z-2 xl:mt-0 xl:mb-0 xl:flex-row-reverse xl:gap-0',
    refillImage: 'h-full w-auto shrink-0 object-contain',
    refillContent:
      'ml-3 flex min-w-0 flex-col justify-center xl:mr-1 xl:ml-0 xl:text-right',
    refillTitle:
      'mb-1 text-[14px] leading-[1.3] font-light tracking-[0.2em] uppercase',
    refillValue:
      'mb-2 [font-family:var(--font-source-serif-4)] text-[68px] leading-[.8] font-light',
    refillValueSmall: 'text-[43px]',
    refillText: 'text-[18px] leading-[1.2] font-light'
  },
  variants: {
    rowType: {
      first: {
        row: 'pt-7 xl:items-start xl:pt-4',
        visual: 'xl:justify-end xl:pt-[62px] xl:pr-[59px]',
        product: 'xl:items-center xl:self-stretch xl:pt-5 xl:pl-[125px]',
        image:
          'max-xl:mt-3 max-xl:-mb-62 xl:relative xl:top-[124px] xl:h-[550px] xl:w-auto xl:scale-[1.55]',
        label: 'xl:top-[11px] xl:-left-[173px]'
      },
      second: {
        row: 'pt-9 xl:flex-row-reverse xl:items-start xl:pt-0',
        visual: 'xl:justify-start xl:pt-[42px] xl:pl-0',
        imageWrap: 'xl:-ml-[99px]',
        product:
          'pt-0 lg:pt-8 xl:items-center xl:justify-end xl:self-stretch xl:pt-10 xl:pr-[120px]',
        image: 'max-xl:mt-3 xl:size-[540px]',
        label: 'xl:top-9 xl:left-[494px] xl:text-right',
        refill: 'xl:bottom-[25px] xl:left-[449px]'
      },
      third: {
        row: 'pt-8 xl:items-start xl:pt-12',
        visual: 'xl:justify-end xl:pr-0',
        imageWrap: 'xl:translate-x-[107px]',
        product: 'xl:items-center xl:self-stretch xl:pl-[125px]',
        image:
          'relative scale-[1] max-xl:-mt-6 lg:scale-[1.1] xl:-top-[52px] xl:size-[520px]',
        label: 'xl:top-[49px] xl:-left-[157px]'
      }
    }
  },
  defaultVariants: {
    rowType: 'first'
  }
});
